import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public'
const secureResource = hubbleAPI + 'secure/public'
export default ($axios) => ({

  createOrder(payload) {
    return $axios.post(`${secureResource}/ct/create-order`, payload)
  },

  addAddressToOrder(payload) {
    return $axios.post(`${resource}/ct/add-address`, payload)
  },
  createOrderNew(payload) {
    return $axios.post(`${resource}/ct/create-order-new`, payload)
  },

  getOrder(payload) {
    return $axios.get(`${resource}/payment/temporary-orders?orderId=${payload}`)
  }

})
